<h2 mat-dialog-title>{{ isNew ? "New Filter Point" : "Edit Filter Point" }}</h2>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Filter key</mat-label>
      <mat-select [(value)]="result.filterKey"><mat-option *ngFor="let k of data.filterKeys" [value]="k.value">{{ k.label }}</mat-option></mat-select></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Display name</mat-label><input matInput [(ngModel)]="result.displayName" name="fdn2" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Type</mat-label>
      <mat-select [(value)]="result.filterType"><mat-option *ngFor="let t of filterTypes" [value]="t.value">{{ t.label }}</mat-option></mat-select></mat-form-field></div>
  </div>
  <mat-form-field class="full-width" *ngIf="result.filterType === 2">
    <mat-label>Definition (JSON)</mat-label>
    <textarea matInput rows="3" [(ngModel)]="result.definitionJson" name="fdj"
      placeholder='{"bridge_table":"job_attributes","bridge_key":"job_key","value_column":"attribute_key"}'></textarea>
  </mat-form-field>
  <mat-form-field class="col-md-6" *ngIf="result.filterType === 3">
    <mat-label>Operator</mat-label>
    <mat-select [(value)]="comparisonOperator">
      <mat-option *ngFor="let o of comparisonOperators" [value]="o.value">{{ o.label }}</mat-option>
    </mat-select>
  </mat-form-field>
  <p class="text-muted" *ngIf="result.filterType === 3">
    The value compared against (and whether it means true/false for a boolean column) is supplied per layout, not here.
  </p>
  <mat-form-field class="full-width"><mat-label>Applies to columns</mat-label>
    <mat-select [(value)]="result.targetColumnIds" multiple>
      <mat-option *ngFor="let c of data.physicalColumns" [value]="c.admTableColumnId">{{ columnLabel(c.admTableColumnId) }}</mat-option>
    </mat-select></mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">Save filter point</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="!isNew" (click)="onToggleRetired()">{{ result.retired ? "Restore" : "Retire" }}</button>
</div>
